// store/modules/nativeFileSelect.js

// 상태 정의
const state = () => ({
	// 파일 객체와 미리보기 URL을 함께 저장할 배열
	// 각 요소는 { file: File, src: string (Data URL), key: string } 형태가 됩니다.
	nativeSelectedFiles: [],
});

// 뮤테이션 정의
const mutations = {
	// 선택된 파일 목록을 업데이트하는 뮤테이션
	SET_NATIVE_SELECTED_FILES(state, files) {
		state.nativeSelectedFiles = files;
	},
	// 파일 목록을 비우는 뮤테이션
	CLEAR_NATIVE_SELECTED_FILES(state) {
		state.nativeSelectedFiles = [];
	},
};

// 액션 정의
const actions = {
	// nativeResultImageSelectButtonClick에서 호출될 액션
	// 파일 데이터를 받아 뮤테이션을 커밋합니다.
	processNativeImages({ commit }, fileList) {
		if (Array.isArray(fileList) && fileList.length > 0) {
			commit('SET_NATIVE_SELECTED_FILES', fileList);
			console.log('Vuex에 네이티브 이미지 데이터가 저장되었습니다.');
		} else {
			commit('CLEAR_NATIVE_SELECTED_FILES');
			alert('스토어 내에 데이터가 들어오지 않았습니다.');
			console.log('네이티브 선택된 이미지 데이터가 없습니다.');
		}
	},
	// 저장된 파일 목록을 초기화하는 액션
	clearNativeImages({ commit }) {
		commit('CLEAR_NATIVE_SELECTED_FILES');
	},
};

// 게터 정의
const getters = {
	// 컴포넌트에서 파일 목록을 가져올 때 사용
	getNativeSelectedFiles(state) {
		return state.nativeSelectedFiles;
	},
	// 선택된 파일의 개수를 반환 (최대 개수 제한 로직에 활용 가능)
	getNativeSelectedFileCount(state) {
		return state.nativeSelectedFiles.length;
	},
};

export default {
	namespaced: true, // 모듈 이름을 사용하여 충돌 방지 (예: nativeFileSelect/getNativeSelectedFiles)
	state,
	mutations,
	actions,
	getters,
};
